import ScalarSidebarItem_default from "./ScalarSidebarItem.vue.js";
import { Fragment, createBlock, createElementBlock, createElementVNode, defineComponent, openBlock, renderList, withCtx } from "vue";
var ScalarSidebarLoading_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "ScalarSidebarLoading",
	props: { items: { default: 4 } },
	setup(__props) {
		return (_ctx, _cache) => {
			return openBlock(true), createElementBlock(Fragment, null, renderList(__props.items, (idx) => {
				return openBlock(), createBlock(ScalarSidebarItem_default, {
					key: idx,
					class: "pointer-events-none"
				}, {
					default: withCtx(() => [..._cache[0] || (_cache[0] = [createElementVNode("div", { class: "group/button-loading bg-sidebar-c-2/15 rounded-lg animate-pulse h-lh w-full box-content py-px -my-px" }, null, -1)])]),
					_: 1
				});
			}), 128);
		};
	}
});
//#endregion
export { ScalarSidebarLoading_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=ScalarSidebarLoading.vue.script.js.map